import { Box, SxProps, Theme } from "@mui/material";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import React, { ReactElement, ReactNode } from "react";

export interface HTMLTextProps {
  /** Text to convert to html */
  children: ReactNode;
  /** sx  */
  sx?: SxProps<Theme>;
}

/** Displays a regular string, or sanitized and parsed HTML text */
export function HTMLText({ children, sx }: HTMLTextProps): ReactElement {
  const htmlString = React.Children.toArray(children).join("");

  if (containsHTML(htmlString)) {
    // Sanitize HTML
    const cleanHtmlString = DOMPurify.sanitize(htmlString, {
      USE_PROFILES: { html: true },
    });

    return (
      <Box sx={sx} data-cy="htmlText">
        {parse(cleanHtmlString)}
      </Box>
    );
  } else {
    return <Box sx={sx}>{htmlString}</Box>;
  }
}

/** Check if text contains HTML */
function containsHTML(text: string) {
  const htmlRegex = /<[a-z][\s\S]*>/i;
  return htmlRegex.test(text);
}
